import {Alert, type AlertColor, Snackbar, type SnackbarOrigin} from "@mui/material";

type Props = {
    message?: string;
    onClose: () => void;
    severity?: AlertColor;
    autoHideDuration?: number;
    anchorOrigin?: SnackbarOrigin;
};

const defaultAnchorOrigin: SnackbarOrigin = {
    vertical: "top",
    horizontal: "center",
};

const ArenaSnackBar: React.FC<Props> = ({
    message,
    onClose,
    severity = "error",
    autoHideDuration = 10000,
    anchorOrigin = defaultAnchorOrigin,
}) => (
    <Snackbar open={Boolean(message)} autoHideDuration={autoHideDuration} onClose={onClose} anchorOrigin={anchorOrigin}>
        <Alert severity={severity} onClose={onClose} sx={{width: "100%"}}>
            {message}
        </Alert>
    </Snackbar>
);

export default ArenaSnackBar;
